export default __webpack_public_path__ + "static/media/registration.3d344e99.svg";